// src/utils/auth.js
import { notification } from 'antd';
import { logout } from '../store/auth/authSlice';

export const REDIRECT_BY_USER_TYPE = {
  admin: '/admin/dashboard',
  organization: '/organisation/dashboard',
  interpreter: '/interpreter/dashboard',
};

export function buildUserDataFromLoginResponse(response, userType) {
  const data = response?.data;
  const nested = data?.data;

  return {
    id: data?._id ?? nested?._id,
    name: data?.full_name ?? nested?.full_name,
    email: data?.email ?? nested?.email,
    type: data?.type ?? userType,
    status: data?.status,
  };
}

export function buildUserDataFromVerified(verifiedData, userType, emailFallback) {
  const nested = verifiedData?.data;

  return {
    id: verifiedData?._id ?? nested?._id,
    name: verifiedData?.full_name ?? nested?.full_name,
    email: verifiedData?.email ?? emailFallback,
    type: verifiedData?.type ?? userType,
    status: verifiedData?.status,
  };
}

export function navigateByUserType(navigate, userType) {
  const path = REDIRECT_BY_USER_TYPE[userType];

  if (path) {
    navigate(path);
    return true;
  }

  notification.error({
    message: 'Access Denied',
    description: `These credentials are not registered as ${userType}. Please select the correct user type.`,
  });

  return false;
}

export const handleLogout = (dispatch, navigate) => {
  try {
    dispatch(logout());
    
    navigate('/auth/login');
  } catch (error) {
  }
};